import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import { Box, CircularProgress, Typography } from "@mui/material";
import DateSelector from "./DateSelector/DateSelector";
import TimeSlotSelector from "./TimeSlotSelector";
import {
  getAvailabilityByDate,
  getAvailabilityForMonth,
} from "../../services/availabilityService";

const DateTimePicker = ({
  selectedDate,
  onDateChange,
  selectedTime,
  onTimeChange,
}) => {
  const [calendarMonth, setCalendarMonth] = useState(dayjs().startOf("month"));

  const [availableSlotsMap, setAvailableSlotsMap] = useState({});
  const [availableTimeSlots, setAvailableTimeSlots] = useState([]);
  const [loadingSlots, setLoadingSlots] = useState(false);
  const [loadingMonth, setLoadingMonth] = useState(false);
  const fetchedMonths = useState(new Set())[0];

  // Fetch month availability
  useEffect(() => {
    const monthKey = calendarMonth.format("YYYY-MM");
    if (fetchedMonths.has(monthKey)) return;

    setLoadingMonth(true);
    getAvailabilityForMonth(calendarMonth.year(), calendarMonth.month() + 1)
      .then((data) => {
        setAvailableSlotsMap((prev) => ({ ...prev, ...data }));
        fetchedMonths.add(monthKey);
      })
      .finally(() => setLoadingMonth(false));
  }, [calendarMonth]);

  // Fetch time slots for selected date
  useEffect(() => {
    if (!selectedDate) return;
    setLoadingSlots(true);

    getAvailabilityByDate(selectedDate.format("YYYY-MM-DD"))
      .then((data) => {
        const isToday = selectedDate.isSame(dayjs(), "day");
        const nowHour = dayjs().hour();

        const filtered = data.slots.filter((s) => {
          const hour = parseInt(s.time.split(":")[0]);
          const notPast = !isToday || hour > nowHour;
          return s.remaining > 0 && notPast;
        });

        setAvailableTimeSlots(filtered);
      })
      .catch((err) => {
        console.error("Error loading slots", err);
        setAvailableTimeSlots([]);
      })
      .finally(() => setLoadingSlots(false));
  }, [selectedDate]);

  return (
    <Box>
      <DateSelector
        calendarMonth={calendarMonth}
        setCalendarMonth={setCalendarMonth}
        selectedDate={selectedDate}
        onDateChange={onDateChange}
        availableSlotsMap={availableSlotsMap}
        loadingMonth={loadingMonth}
      />

      <TimeSlotSelector
        selectedDate={selectedDate}
        selectedTime={selectedTime}
        onTimeChange={onTimeChange}
        timeSlots={availableTimeSlots}
        loading={loadingSlots}
      />

      {selectedDate && selectedTime && (
        <Box
          mt={4}
          p={2}
          border="1px solid"
          borderColor="grey.300"
          borderRadius={2}
          bgcolor="#fdf7f6">
          <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
            Your Selected Time
          </Typography>
          <Typography>
            🗓 {selectedDate.format("dddd, MMMM D")} at {selectedTime}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default DateTimePicker;
